import React, { useState } from "react";
import { useSelector } from "react-redux";

const ActiveSubscriptionCard = ({ activeSubscription, onCancelSuccess }) => {
  const [loading, setLoading] = useState(false);
  const { token } = useSelector((state) => state.auth);

  if (!activeSubscription) {
    return (
      <div style={styles.container}>
        <h3 style={styles.title}>Souscription active</h3>
        <p>Aucune souscription active pour le moment.</p>
      </div>
    );
  }

  const { offer, startDate, endDate, statusSubscription, autoRenew } = activeSubscription;

  const handleCancel = async () => {
    if (!window.confirm("Annuler le renouvellement automatique ?")) return;

    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/subscription/cancel`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();

      if (!response.ok) {
        alert(data.error || "Erreur lors de l'annulation");
      } else {
        alert("Le renouvellement automatique a été annulé.");
        if (onCancelSuccess) onCancelSuccess(); // refresh parent
      }
    } catch (err) {
      console.error(err);
      alert("Erreur serveur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <h3 style={styles.title}>Souscription active</h3>

      <div style={styles.row}>
        <strong>Offre :</strong> <span>{offer.titleOffer}</span>
      </div>

      <div style={styles.row}>
        <strong>Prix :</strong>
        <span>
          {offer.priceOfferTTC.toFixed(2)}€ /{" "}
          {offer.durationDays === 30 ? "mois" : "jours"}
        </span>
      </div>

      <div style={styles.row}>
        <strong>Statut :</strong>
        <span style={statusSubscription === "active" ? styles.active : styles.inactive}>
          {statusSubscription}
        </span>
      </div>

      <div style={styles.row}>
        <strong>Début :</strong> <span>{startDate}</span>
      </div>

      <div style={styles.row}>
        <strong>Fin :</strong> <span>{endDate}</span>
      </div>

      <div style={styles.row}>
        <strong>Renouvellement auto :</strong> <span>{autoRenew ? "Oui" : "Non"}</span>
      </div>

      {/* Bouton uniquement si autoRenew actif */}
      {autoRenew && statusSubscription === "active" && (
        <button
          onClick={handleCancel}
          disabled={loading}
          style={styles.cancelBtn}
        >
          {loading ? "Annulation..." : "Annuler le renouvellement"}
        </button>
      )}
    </div>
  );
};

const styles = {
  container: {
    background: "#fff",
    padding: "18px",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    maxWidth: "420px",
    margin: "auto",
    fontFamily: "sans-serif",
  },
  title: {
    marginBottom: "14px",
    color: "#333",
    textAlign: "center"
  },
  row: {
    marginBottom: "6px",
    display: "flex",
    justifyContent: "space-between"
  },
  active: {
    color: "green",
    fontWeight: "bold"
  },
  inactive: {
    color: "red",
    fontWeight: "bold"
  },
  cancelBtn: {
    marginTop: "12px",
    width: "100%",
    padding: "10px",
    background: "#e74c3c",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer"
  }
};

export default ActiveSubscriptionCard;
